import * as z from "zod";

export const aboutFormSchema = z.object({
  title: z.string().min(1).max(255),
  description: z.string().min(1),
  body_simple: z.string().min(1),
  body_wysiwyg: z.string().min(1),
  icon_name: z.string().min(1).max(100),
  order: z.coerce.number().int().min(0),
  is_active: z.boolean(),
});
